module.exports = __webpack_public_path__ + "static/media/logo.a470ba73.svg";